<template lang="html">
    <section class="date-order-windows">
        <div v-if="orderWindowDate" class="col-lg-9 col-md-9 col-xs-12 row">
            <div class="orders-windows-created col-md-6 col-xs-12">
                {{ $t("orders.labelCreated") }} {{ orderWindowDate.createdAt }} {{ $t("orders.labelCreatedBy") }}
                {{ fullNameFormat(orderWindowDate.createdBy) }}
            </div>

            <div class="orders-windows-update col-md-6 col-xs-12">
                {{ $t("orders.labelLastUpdate") }} {{ orderWindowDate.modifiedDate }} {{ $t("orders.labelLastUpdateBy") }}
                {{ fullNameFormat(orderWindowDate.modifiedBy) }}
            </div>
        </div>
    </section>
</template>

<script lang="js">
  export default  {
    name: 'date-order-windows',
    props: ["orderWindowDate"],
    methods: {
        fullNameFormat(objName) {
            return (objName) ? objName.firstname + " " + objName.lastname : ''
        }
    }
}
</script>

<style scoped lang="scss">
.date-order-windows {
}
</style>



// WEBPACK FOOTER //
// dateOrderWindows.vue?e5a75326